<mat-card>
    <mat-card-content>
        <mat-toolbar color="primary">Contatos</mat-toolbar>
        <div class="flex-item">
            @if (contato.nmFilial) {
            <div class="campo-dados">
                <strong> Filial:</strong>
                <span>{{contato.nmFilial}}</span>
            </div>
            }
            <mat-divider></mat-divider>
            @if (contato.nmCidade) {
            <div class="campo-dados">
                <strong>Cidade: </strong>
                <span>{{contato.nmCidade}}</span>
            </div>
            }
            <mat-divider></mat-divider>
            @if (contato.uf) {
            <div class="campo-dados">
                <strong> Estado:</strong>
                <span>{{contato.uf}}</span>
            </div>
            }
            <mat-divider></mat-divider>
            @if (contato.bairro) {
            <div class="campo-dados">
                <strong>Bairro: </strong>
                <span>{{contato.bairro}}</span>
            </div>
            }
            <mat-divider></mat-divider>
            @if (contato.telefoneFilial) {
            <div class="campo-dados">
                <strong>Telefone filial: </strong>
                <span>{{contato.telefoneFilial}}</span>
            </div>
            }
            <mat-divider></mat-divider>
            @if (contato.nmFuncionario) {
            <div class="campo-dados">
                <strong>Vendedor: </strong>
                <span>{{contato.nmFuncionario}}</span>
            </div>
            }
            <mat-divider></mat-divider>
            @if (contato.telefoneFixoComercial) {
            <div class="campo-dados">
                <strong>Telefone: </strong>
                <span>{{formataCelular(contato.telefoneFixoComercial)}}</span>
            </div>
            }
            <mat-divider></mat-divider>
            @if (contato.emailComercial) {
            <div class="campo-dados">
                <strong>Email: </strong>
                <span>{{contato.emailComercial}}</span>
            </div>
            }
            <mat-divider></mat-divider>
            @if (contato.celularComercial) {
            <div class="campo-dados">
                <strong>Celular: </strong>
                <span>{{formataCelular(contato.celularComercial)}}</span>
            </div>
            }
        </div>
    </mat-card-content>
</mat-card>
